import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const domainService = {
  _url: process.env.REACT_APP_DOMAIN_API_URL,

  GetAllDomains(searchQuery, fetch) {
    const [domains, setDomains] = useState({
      domains: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [domainStatus, setDomainStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setDomainStatus(STATUS.LOADING);
      cancellablePromise(this.getAllDomains(searchQuery))
        .then(res => {
          setDomains(() => res);
          setDomainStatus(STATUS.SUCCESS);
        })
        .catch(() => setDomainStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      domains_loading: domainStatus === STATUS.LOADING,
      domains_error: domainStatus === STATUS.ERROR,
      domains_data: domains,
    };
  },

  GetAllEmails(searchQuery, fetch) {
    const [emails, setEmails] = useState({
      emails: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [emailStatus, setEmailStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setEmailStatus(STATUS.LOADING);
      cancellablePromise(this.getAllEmails(searchQuery))
        .then(res => {
          setEmails(() => res);
          setEmailStatus(STATUS.SUCCESS);
        })
        .catch(() => setEmailStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      emails_loading: emailStatus === STATUS.LOADING,
      emails_error: emailStatus === STATUS.ERROR,
      emails_data: emails,
    };
  },

  async getAllEmails({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    startDate = '',
    endDate = '',
    domain,
  }) {
    let res = await Fetch.get(
      `${this._url}/get-all-email-identities?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}&domain=${domain}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async getAllDomains({ page = 1, itemsPerPage = 10, searchText = '', getAll = false, startDate = '', endDate = '' }) {
    let res = await Fetch.get(
      `${this._url}/get-all-domains?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async createDomain(payload) {
    let res = await Fetch.post(`${this._url}/add-domain`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteDomain(id) {
    let res = await Fetch.delete(`${this._url}/delete-domain/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createDomainEmail(payload) {
    let res = await Fetch.post(`${this._url}/add-email-identities`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async LinkSingleIdentityEmail(payload) {
    let res = await Fetch.post(`${this._url}/send-verification-email`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteDomainEmail(id) {
    let res = await Fetch.delete(`${this._url}/delete-domain-email-identity/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async deleteSigleIdentityEmail(id) {
    let res = await Fetch.delete(`${this._url}/delete-single-identity-email/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default domainService;
